import type {DocumentManager} from '@wix/document-manager-core'
import type {PageExtensionAPI} from '../../../page'
import * as constants from '../../../../constants/constants'
import type {PageMigrator} from '../dataMigrationRunner'
const {MASTER_PAGE_ID} = constants

const migratePage = (documentManager: DocumentManager, pageId: string) => {
    if (pageId !== MASTER_PAGE_ID) {
        const {page} = documentManager.extensionAPI as PageExtensionAPI
        const pagePointer = documentManager.pointers.structure.getPage(pageId, constants.VIEW_MODES.DESKTOP)
        page.data.update(pagePointer, page.data.get(pageId), false)
    }
}

const name = 'fixPageBackgroundNodeLocation'
const version = 2

export const fixPageBackgroundNodeLocation: PageMigrator = {
    migratePage,
    name,
    version
}
